/**
 * GTD Domain - Bounded Contexts Export
 * 
 * Exports application services and domain components from all bounded contexts
 * within the GTD domain for use by MCP tools and external consumers.
 */

// Inbox Management Bounded Context
export { InboxItemApplicationService } from './inbox-management/application/services/InboxItemApplicationService';

// Project Management Bounded Context  
export { ProjectApplicationService } from './project-management/application/services/ProjectApplicationService';

// Design Implementation Coordination Bounded Context
export { DesignImplementationFlowApplicationService } from './design-implementation-coordination/application/services/DesignImplementationFlowApplicationService';
export { DesignImplementationFlowReadService } from './design-implementation-coordination/application/services/DesignImplementationFlowReadService';

// Task Management Bounded Context
// Note: WeeklyReviewApplicationService would be part of a review management context
// For now, we'll create a stub to satisfy the MCP exports

/**
 * Placeholder Weekly Review Application Service
 * TODO: Implement proper weekly review bounded context
 */
export class WeeklyReviewApplicationService {
  async conductWeeklyReview(params: any) {
    return {
      success: true,
      message: 'Weekly review service not yet implemented',
      reviewId: 'placeholder-review',
      phases: []
    };
  }
}